import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

class Alert extends Component {
  render() {
    const {verified, email, tradingDisabled, location} = this.props;

    let isKyc;

    if (location && location.pathname) {
      isKyc = location.pathname === '/kyc';
    }

    if ( tradingDisabled && !isKyc) {
      return (
        <div className="alert-container">
          <div className="alert">
            <b>Trading Down For Maintenance:</b> New trades are temporarily down while we carry out some routine maintenance, and will return shortly.
          </div>
        </div>
      );
    }

    if (!verified && !email && !isKyc) {
      return (
        <div className="alert-container">
          <div className="alert">
            <b>Email & Account Unverified:</b> Please complete your <a href="/kyc">Identity</a> and check your inbox for link to verify your email. You can request a new email in your <a href="/settings">settings</a>.
          </div>
        </div>
      );
    }

    if (!verified && email && !isKyc) {
      return (
        <div className="alert-container">
          <div className="alert">
            <b>Account Unverified:</b> Please fill in your <a href="/kyc">Identity</a> and upload your documents.
          </div>
        </div>
      );
    }

    if (verified && !email && !isKyc) {
      return (
        <div className="alert-container">
          <div className="alert">
            <b>Email Unverified:</b> Please check your inbox for a link to verify your email. You can request a new email in your <a href="/settings">settings</a>.
          </div>
        </div>
      );
    }

    return (null);
  }
}

export default withRouter(Alert);
